import React from 'react';
import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseArrowIcon = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
    </svg>
);

export const ArrowIcon = styled(BaseArrowIcon)`
    path {
        fill: ${({ theme }) => theme.palette.background.paper};
    }
`;
